import { CloseFill18Icon } from "@vygruppen/spor-icon-react";
import { Dispatch, FC, SetStateAction } from "react";
import { useTranslation } from "react-i18next";
import { ActionModal } from "shared/components/ActionModal";
import {
  ChoiceChip,
  DropsButton,
  Flex,
  HStack,
  Text,
} from "shared/components/Spor";
import { toggle } from "shared/utils/objectUtils";
import { useTheme } from "styled-components";

const allTrainSeries = [
  "6x", // Special case, test it thoroughly if you make any changes
  "1xx",
  "2xx",
  "3xx",
  "5xx",
  "6xx",
  "8xx",
  "10xx",
  "11xx",
  "12xx",
  "15xx",
  "16xx",
  "18xx",
  "19xx",
  "21xx",
  "22xx",
  "24xx",
  "25xx",
  "26xx",
  "27xx",
  "28xx",
  "29xx",
  // "121xx", too specific
  // "173xx", too specific
  // "174xx", too specific
];

type SelectTrainSeriesProps = {
  onClose: () => void;
  onSubmit: () => void;
  trainSeries: string[];
  setTrainSeries: Dispatch<SetStateAction<string[]>>;
  isEditMode: boolean;
};

export const SelectTrainSeries: FC<SelectTrainSeriesProps> = ({
  onClose,
  onSubmit,
  trainSeries,
  setTrainSeries,
  isEditMode,
}) => {
  const theme = useTheme();
  const { t } = useTranslation();
  return (
    <ActionModal
      title={`${isEditMode ? t("Endre") : t("Opprett")} ${t("produksjonsavvik")}`}
      actionTitle={`${t("Neste")} →`}
      onClose={onClose}
      isSubmitDisabled={trainSeries.length === 0}
      onSubmit={onSubmit}
      loading={false}
      isSuccess={false}
      isError={false}
      successMessage=""
      failureMessage=""
    >
      <Flex flexDir="column" gap="12px">
        <HStack justifyContent="space-between">
          <Text my="3px">{t("Velg berørte togserier")}</Text>
          {trainSeries.length > 0 && (
            <DropsButton
              size="xs"
              variant="ghost"
              fontWeight="400"
              leftIcon={<CloseFill18Icon m="auto" />}
              onClick={() => setTrainSeries([])}
            >
              {t("Avmarker valgte")}
            </DropsButton>
          )}
        </HStack>
        <Flex w="100%" gap="6px" flexWrap="wrap">
          {allTrainSeries.map((it) => (
            <ChoiceChip
              key={it}
              size="xs"
              checked={trainSeries.includes(it)}
              onCheckedChange={() =>
                setTrainSeries(
                  toggle(trainSeries, it).toSorted((a, b) => {
                    const asNumber = (ts: string) =>
                      parseInt(ts.replace("x", "0"), 10);
                    return asNumber(a) - asNumber(b);
                  }),
                )
              }
              borderRadius="6px"
              outlineColor={theme.colorSuccessOutline}
            >
              <Text variant="xs">{it}</Text>
            </ChoiceChip>
          ))}
        </Flex>
      </Flex>
    </ActionModal>
  );
};
